import React from "react";
import analytics from "web/script/analytics/analytics";
import { openAppHeaderSearch, closeAppHeaderSearch } from "web/redux/ducks/app-header-search";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import styles from "./search-button.css";

function extractState(state: ReduxStoreState): boolean {
    return state.appHeaderSearchReducer.open;
}

export function SearchButton(): JSX.Element {
    const isSearchBarOpen = useReduxSelector(extractState);
    const dispatch = useDispatch();

    function onSearchClick(): void {
        let searchBar = document.querySelector(".app-header-bar-burger");
        if (searchBar && !isSearchBarOpen) {
            dispatch(openAppHeaderSearch());
        } else if (isSearchBarOpen) {
            dispatch(closeAppHeaderSearch());
        }
        analytics.event("header", "clicked", "burger_menu_search_button_open");
    }

    return (
        <a id="searchButton" onClick={onSearchClick} className={styles.iconWrapper}>
            <SVGIcon className={styles.icon} name="search-icon" />
        </a>
    );
}

export default withReduxProvider(SearchButton);
